/**
 * Cart Swap to Duo — v5 (inline undo on swapped product)
 */
(function () {
  'use strict';

  const DUO_COLLECTION_PATH = '/collections/duo/products.json?limit=50';
  const TAG_PREFIX = 'contains:';
  let duoProducts = null;
  let duoFetchFailed = false;
  let initRunning = false;

  function getDuoCollectionUrl() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const base = root.endsWith('/') ? root.slice(0, -1) : root;
    return base + DUO_COLLECTION_PATH;
  }

  async function getDuos() {
    if (duoProducts && duoProducts.length > 0) return duoProducts;
    if (duoProducts && duoProducts.length === 0 && duoFetchFailed) {
      duoProducts = null;
      duoFetchFailed = false;
    }
    if (duoProducts) return duoProducts;
    try {
      const res = await fetch(getDuoCollectionUrl());
      if (!res.ok) {
        console.warn('[cart-swap] Duo collection fetch failed:', res.status);
        duoProducts = [];
        duoFetchFailed = true;
        return duoProducts;
      }
      const data = await res.json();
      duoProducts = data.products || [];
      if (!duoProducts.length) {
        console.warn('[cart-swap] Duo collection is empty or not found');
        duoFetchFailed = true;
      }
    } catch (e) {
      console.warn('[cart-swap] Duo collection fetch error:', e);
      duoProducts = [];
      duoFetchFailed = true;
    }
    return duoProducts;
  }

  function findDuosFor(handle) {
    if (!duoProducts) return [];
    return duoProducts.filter(duo =>
      duo.tags.some(tag => tag.toLowerCase() === TAG_PREFIX + handle.toLowerCase())
    );
  }

  async function cartRemove(variantId) {
    const res = await fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId.toString(), quantity: 0 }),
    });
    if (!res.ok) throw new Error('Remove failed');
    return res.json();
  }

  async function cartAdd(variantId, qty = 1) {
    const res = await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
  }

  function renderSwapUI(slot, duos, singleVariantId, singleHandle) {
    if (slot.querySelector('.swap-duo-widget')) return;

    const widget = document.createElement('div');
    widget.className = 'swap-duo-widget';
    widget.style.opacity = '0';

    let html = `<div class="swap-duo-widget__label">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4"/></svg>
      Swap to a Duo & Save
    </div>`;
    html += '<div class="swap-duo-widget__options">';

    duos.forEach(duo => {
      const variant = duo.variants[0];
      const price = Math.round(parseFloat(variant.price));
      const comparePrice = variant.compare_at_price ? Math.round(parseFloat(variant.compare_at_price)) : 0;
      const savings = comparePrice > price ? comparePrice - price : 0;
      const img = duo.images[0] ? duo.images[0].src.replace(/\.([^.]+)$/, '_120x120.$1') : '';

      html += `
        <button class="swap-duo-widget__btn" type="button"
          data-duo-variant="${variant.id}"
          data-duo-title="${duo.title}"
          data-single-variant="${singleVariantId}"
          data-single-handle="${singleHandle}">
          ${img ? `<img src="${img}" alt="" class="swap-duo-widget__img" width="44" height="44" loading="lazy">` : ''}
          <span class="swap-duo-widget__info">
            <span class="swap-duo-widget__title">${duo.title}</span>
            <span class="swap-duo-widget__price">₹${price}${comparePrice ? ` <s>₹${comparePrice}</s>` : ''}${savings ? ` <em class="swap-duo-widget__save">Save ₹${savings}</em>` : ''}</span>
          </span>
          <span class="swap-duo-widget__action">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4"/></svg>
            Swap
          </span>
        </button>
      `;
    });
    html += '</div>';
    widget.innerHTML = html;
    slot.appendChild(widget);

    requestAnimationFrame(() => {
      widget.style.transition = 'opacity 0.25s ease';
      widget.style.opacity = '1';
    });

    widget.querySelectorAll('.swap-duo-widget__btn').forEach(btn => {
      btn.addEventListener('click', handleSwap);
    });
  }

  async function handleSwap(e) {
    const btn = e.currentTarget;
    const duoVariantId = btn.dataset.duoVariant;
    const singleVariantId = btn.dataset.singleVariant;

    const allBtns = btn.closest('.swap-duo-widget').querySelectorAll('.swap-duo-widget__btn');
    allBtns.forEach(b => { b.style.pointerEvents = 'none'; b.style.opacity = '0.5'; });

    const actionEl = btn.querySelector('.swap-duo-widget__action');
    actionEl.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="swap-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Swapping`;

    try {
      await cartRemove(singleVariantId);
      await cartAdd(parseInt(duoVariantId));

      // Store undo data — supports multiple swaps independently
      const undoList = JSON.parse(sessionStorage.getItem('swap_undo_list') || '[]');
      undoList.push({ singleVariantId, duoVariantId });
      sessionStorage.setItem('swap_undo_list', JSON.stringify(undoList));

      actionEl.textContent = '✓ Done';
      await new Promise(r => setTimeout(r, 250));

      refreshDrawer();
    } catch (err) {
      console.error('[cart-swap] Swap failed:', err);
      allBtns.forEach(b => { b.style.pointerEvents = ''; b.style.opacity = ''; });
      actionEl.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4"/></svg> Swap`;
    }
  }

  async function init() {
    if (initRunning) return;
    initRunning = true;

    // Migrate old single-entry undo to new list format
    const oldUndo = sessionStorage.getItem('swap_undo');
    if (oldUndo) {
      try {
        const entry = JSON.parse(oldUndo);
        const list = JSON.parse(sessionStorage.getItem('swap_undo_list') || '[]');
        if (!list.some(item => item.duoVariantId === entry.duoVariantId)) {
          list.push(entry);
          sessionStorage.setItem('swap_undo_list', JSON.stringify(list));
        }
      } catch (e) {}
      sessionStorage.removeItem('swap_undo');
    }

    const slots = document.querySelectorAll('.swap-duo-slot[data-product-handle]');
    if (!slots.length) {
      console.log('[cart-swap] No swap-duo-slot elements found');
      initRunning = false;
      return;
    }

    await getDuos();
    if (!duoProducts.length) {
      console.log('[cart-swap] No duo products available');
      initRunning = false;
      return;
    }

    console.log('[cart-swap] Found', slots.length, 'slots,', duoProducts.length, 'duo products');

    slots.forEach(slot => {
      const handle = slot.dataset.productHandle;
      const variantId = slot.dataset.variantId;
      if (!handle || !variantId) return;

      if (slot.querySelector('.swap-duo-widget')) return;

      const matchingDuos = findDuosFor(handle);
      if (matchingDuos.length === 0) return;

      const isDuo = duoProducts.some(d => d.handle === handle);
      if (isDuo) return;

      renderSwapUI(slot, matchingDuos, variantId, handle);
    });

    // Render undo button on swapped product
    renderUndoOnItem();

    initRunning = false;
  }

  function renderUndoOnItem() {
    const undoList = JSON.parse(sessionStorage.getItem('swap_undo_list') || '[]');
    if (!undoList.length) return;

    const cartItems = document.querySelectorAll('.wt-cart__item');

    undoList.forEach(({ singleVariantId, duoVariantId }) => {
      let targetItem = null;

      cartItems.forEach(item => {
        const input = item.querySelector(`input[data-quantity-variant-id="${duoVariantId}"]`);
        if (input) targetItem = item;
      });

      if (!targetItem) return;
      if (targetItem.querySelector('.swap-undo-btn')) return;

      const nameEl = targetItem.querySelector('.wt-cart__item__name');
      if (!nameEl) return;

      const undoBtn = document.createElement('button');
      undoBtn.className = 'swap-undo-btn';
      undoBtn.type = 'button';
      undoBtn.innerHTML = `
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
        Undo
      `;

      nameEl.insertAdjacentElement('afterend', undoBtn);

      undoBtn.addEventListener('click', async () => {
        undoBtn.style.pointerEvents = 'none';
        undoBtn.innerHTML = `
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="swap-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
          ...
        `;

        try {
          await cartRemove(duoVariantId);
          await cartAdd(parseInt(singleVariantId));

          // Remove only this entry from the undo list
          const currentList = JSON.parse(sessionStorage.getItem('swap_undo_list') || '[]');
          const updated = currentList.filter(item => item.duoVariantId !== duoVariantId);
          sessionStorage.setItem('swap_undo_list', JSON.stringify(updated));

          refreshDrawer();
        } catch (err) {
          console.error('[cart-swap] Undo failed:', err);
          undoBtn.style.pointerEvents = '';
          undoBtn.innerHTML = `
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
            Undo
          `;
        }
      });
    });
  }

  let debounceTimer = null;
  const observer = new MutationObserver((mutations) => {
    // Only react to childList changes (DOM structure changes, not attributes)
    const hasStructuralChange = mutations.some(m => m.type === 'childList');
    if (!hasStructuralChange) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      // Only init if we have a populated cart list with actual items
      const list = document.querySelector('.wt-cart__list');
      const hasItems = list && list.querySelector('.wt-cart__item');
      if (hasItems) {
        initRunning = false;
        init();
      }
    }, 500);
  });

  function startObserving() {
    observer.disconnect();
    // Observe cart-drawer custom element — it never gets destroyed from DOM
    const container = document.querySelector('cart-drawer');
    if (container) observer.observe(container, { childList: true, subtree: true });
  }

  function watchDrawerOpen() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const obs = new MutationObserver(() => {
      if (drawer.hasAttribute('open')) {
        initRunning = false;
        setTimeout(() => { startObserving(); init(); }, 150);
      }
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); startObserving(); watchDrawerOpen(); });
  } else {
    init();
    startObserving();
    watchDrawerOpen();
  }

  // Listen for Shopify's pub/sub cart update event (fires after DOM is updated)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      // Wait for DOM to fully settle after cart update
      setTimeout(() => {
        initRunning = false;
        init();
      }, 400);
    });
  }

  document.addEventListener('cart-drawer:refresh-complete', () => {
    initRunning = false;
    setTimeout(() => { startObserving(); init(); }, 200);
  });

  document.addEventListener('cart:refresh', () => {
    initRunning = false;
    setTimeout(() => { startObserving(); init(); }, 200);
  });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => { initRunning = false; startObserving(); watchDrawerOpen(); init(); }, 300);
  });
})();
